
<template>
  <pnet-validation-observer>
    <div>
      <div v-if="label" class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>
              <small>{{label}}</small>
            </label>
            <b-form-textarea
              input-class="form-control text-left"
              label-class="text-left"
              layout="vertical"
              :rows="displayedRows"
              v-model="rawValue"
              :rules="{required:true}"
              :customMessages="{required:'Il campo deve essere valorizzato.'}"
              :disabled="readonly"
            ></b-form-textarea>
          </div>
        </div>
      </div>
      <div v-if="!label">
        <b-form-textarea
          input-class="form-control text-left"
          label-class="text-left"
          layout="vertical"
          :rows="displayedRows"
          v-model="rawValue"
          :rules="{required:true}"
          :customMessages="{required:'Il campo deve essere valorizzato.'}"
          :disabled="readonly"
        ></b-form-textarea>
      </div>
    </div>
  </pnet-validation-observer>
</template>

<script lang="js">
import Vue from "vue";
export default Vue.extend({
  props: ["label", "value", "readonly","rows"],
  components:{
  },
  data: function() {
    return {
      rawValue: null,
      displayedRows: 1,
    }
  },
  methods: {},
  mounted() {
    this.rawValue = this.value;
    if (this.rows !== undefined) {
      this.displayedRows = this.rows;
    }
  },
  watch: {
    rawValue: {
      deep:true,
      immediate: true,
      handler(){
        this.$emit('input', this.rawValue);
      }
    },
    value: {
      deep:true,
      immediate: true,
      handler(){
        this.rawValue = this.value;
      }
    }
  }
});
</script>
